// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAVbMLPXml1q28zftCrRv-69JK7qtiLHjQ",
  authDomain: "leetcodereminder-f3e9a.firebaseapp.com",
  projectId: "leetcodereminder-f3e9a",
  storageBucket: "leetcodereminder-f3e9a.appspot.com",
  messagingSenderId: "66507902325",
  appId: "1:66507902325:web:abc1c551ae070f4b52173c",
  measurementId: "G-7V5E8QTRJX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };